import { makeStyles } from '@material-ui/styles'
import Theme from '@refera/ui-core'

export default makeStyles(({ spacing }) => ({
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    padding: spacing(24, 24, 34, 36),
  },
  columnAccordion: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  rowAccordion: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
  },
  buttonsWrapper: {
    display: 'flex',
    gap: spacing(10),
  },
  materialsGridContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(16),
  },
  formColumns: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: spacing(24),
    width: '100%',
    marginBottom: spacing(16),
  },
  column: {
    width: '100%',
    gap: spacing(16),
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
  },
  button: {
    padding: spacing(4, '!important'),
    height: 'fit-content',
    width: '200px',
    alignSelf: 'flex-end',
  },
  totalText: {
    marginTop: '-20px',
    fontSize: '17px',
  },
  aiLabel: {
    fontWeight: 600,
    color: Theme.Colors.Grayscale.OneThousand,
    fontSize: spacing(14),
  },
}))
